import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

interface ExternalLinkProps {
    url: string;
    redirectTo?: string;
}

export const ExternalLink: React.FC<ExternalLinkProps> = ({ url, redirectTo = "/dashboard" }) => {
    useEffect(() => {
        window.open(url, "_blank");
    }, [url]);

    return <Navigate to={redirectTo} replace />;
};